<div class="app-footer">
  <div class="app-footer__inner">
    <div class="app-footer-left">
      <span class="pl-2">Copyright 2023 - <a href="https://dashboardpack.com">fractalite.com</a></span>
    </div>
    
  </div>
</div>

